import { render, staticRenderFns } from "./valid.vue?vue&type=template&id=0504948d&scoped=true"
import script from "./valid.vue?vue&type=script&lang=js"
export * from "./valid.vue?vue&type=script&lang=js"
import style0 from "./valid.vue?vue&type=style&index=0&id=0504948d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0504948d",
  null
  
)

export default component.exports